module.exports = __webpack_public_path__ + "static/media/project.9b9daa26.png";